/**
 * Bolderglow Social Proof — carousel + tap video or photo to expand in modal (closable).
 */
(function () {
  function qsa(root, sel) {
    return Array.from(root.querySelectorAll(sel));
  }

  function initCarousel(carouselRoot, sectionEl) {
    if (!carouselRoot || carouselRoot.dataset.bgtkCarouselReady === '1') return null;

    const track = carouselRoot.querySelector('[data-bgtk-track]');
    const viewport = carouselRoot.querySelector('[data-bgtk-viewport]');
    const initialSlides = qsa(carouselRoot, '[data-bgtk-slide]');
    if (!track || !viewport || initialSlides.length === 0) return null;

    const realSlideCount = initialSlides.length;

    function hasMultiSlides() {
      return realSlideCount > 1;
    }

    if (hasMultiSlides() && carouselRoot.dataset.carouselMobile === 'true') {
      sectionEl.classList.add('bgtk-section--mobile-peek');
      carouselRoot.dataset.mobilePeek = 'true';
      carouselRoot.dataset.mobileBottomNav = 'true';
    }

    function injectMobileFootIfNeeded() {
      if (!hasMultiSlides() || carouselRoot.dataset.carouselMobile !== 'true') return;
      if (carouselRoot.querySelector('.bgtk-mobile-carousel-foot')) return;
      var foot = document.createElement('div');
      foot.className = 'bgtk-mobile-carousel-foot';
      foot.innerHTML =
        '<div class="bgtk-footer-carrows" role="group" aria-label="Slide navigation">' +
        '<button type="button" class="bgtk-carrow bgtk-carrow--prev bgtk-carrow--foot" data-bgtk-prev aria-label="Previous slide">' +
        '<svg viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
        '<path d="M9 12L4 7l5-5" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/>' +
        '</svg></button>' +
        '<button type="button" class="bgtk-carrow bgtk-carrow--next bgtk-carrow--foot" data-bgtk-next aria-label="Next slide">' +
        '<svg viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
        '<path d="M5 12l5-5-5-5" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/>' +
        '</svg></button></div>';
      carouselRoot.appendChild(foot);
    }
    injectMobileFootIfNeeded();

    const carouselDesktop = carouselRoot.dataset.carouselDesktop === 'true';
    const carouselMobile = carouselRoot.dataset.carouselMobile === 'true';
    const autoplayDesktop = carouselRoot.dataset.autoplayDesktop === 'true';
    const autoplayMobile = carouselRoot.dataset.autoplayMobile === 'true';
    const intervalMs = Math.max(2000, parseInt(carouselRoot.dataset.intervalMs || '5000', 10));
    const slidesDesktop = Math.max(1, Math.min(4, parseInt(carouselRoot.dataset.slidesDesktop || '4', 10)));
    const loop = true;
    const showArrows = carouselRoot.dataset.showArrows === 'true';

    const mqMobile = window.matchMedia('(max-width: 749px)');

    function isMobile() {
      return mqMobile.matches;
    }

    let slides = initialSlides;
    let useCloneLoop = false;
    let index = 0;

    /*
     * Mobile infinite loop — same idea as CodePen swcarrey/LmMJLd + SO "infinity loop slider":
     * clone last before first, clone first after last; start at index 1 (first real slide).
     * After transition, if on a clone (index === 0 || index > realSlideCount), snap to matching real slide.
     */
    if (hasMultiSlides() && carouselMobile && isMobile()) {
      var lastOrig = slides[realSlideCount - 1];
      var firstOrig = slides[0];
      var cloneLast = lastOrig.cloneNode(true);
      var cloneFirst = firstOrig.cloneNode(true);
      [cloneLast, cloneFirst].forEach(function (node) {
        node.setAttribute('data-bgtk-clone', '1');
        node.setAttribute('aria-hidden', 'true');
        node.removeAttribute('id');
        node.querySelectorAll('video').forEach(function (v) {
          v.removeAttribute('autoplay');
          try {
            v.pause();
          } catch (e) {}
        });
      });
      track.insertBefore(cloneLast, track.firstChild);
      track.appendChild(cloneFirst);
      slides = qsa(carouselRoot, '[data-bgtk-slide]');
      useCloneLoop = true;
      index = 1;
      carouselRoot.dataset.bgtkCloneLoop = '1';
    }

    carouselRoot.dataset.bgtkCarouselReady = '1';

    let timer = null;
    let touchStartX = 0;
    let touchStartY = 0;

    function carouselActive() {
      if (isMobile()) return carouselMobile;
      return carouselDesktop;
    }

    function peekWidths() {
      return isMobile() && carouselMobile && hasMultiSlides();
    }

    function slidesPerView() {
      if (!carouselActive()) return slides.length;
      return isMobile() ? 1 : Math.min(slidesDesktop, realSlideCount);
    }

    function maxIndex() {
      if (!carouselActive()) return Math.max(0, slides.length - slidesPerView());
      if (useCloneLoop && isMobile() && carouselMobile) return slides.length - 1;
      return Math.max(0, realSlideCount - slidesPerView());
    }

    function slideStepPx() {
      const vw = viewport.getBoundingClientRect().width;
      const spv = slidesPerView();
      if (carouselActive() && peekWidths() && slides[0]) {
        const gapStr = getComputedStyle(track).gap || '0px';
        const gap = parseFloat(gapStr) || 0;
        const sw = slides[0].getBoundingClientRect().width;
        if (sw > 0) return sw + gap;
        return vw * 0.65 + gap;
      }
      return spv > 0 ? vw / spv : vw;
    }

    function applyTransform(instantWrap) {
      if (!carouselActive()) {
        track.style.transform = '';
        track.style.removeProperty('transition');
        return;
      }
      const step = slideStepPx();
      const offset = index * step;
      if (instantWrap) {
        track.style.setProperty('transition', 'none', 'important');
        track.style.transform = 'translate3d(' + -offset + 'px, 0, 0)';
        void track.offsetWidth;
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            track.style.removeProperty('transition');
          });
        });
        return;
      }
      track.style.transform = 'translate3d(' + -offset + 'px, 0, 0)';
    }

    function setSlideWidths() {
      if (!carouselActive()) {
        slides.forEach(function (s) {
          s.style.flexBasis = '';
          s.style.width = '';
          s.style.minWidth = '';
          s.style.maxWidth = '';
        });
        return;
      }
      if (peekWidths()) {
        slides.forEach(function (s) {
          s.style.flexBasis = '';
          s.style.width = '';
          s.style.minWidth = '';
          s.style.maxWidth = '';
        });
        return;
      }
      const spv = slidesPerView();
      const pct = 100 / spv;
      slides.forEach(function (s) {
        s.style.flexBasis = pct + '%';
        s.style.width = pct + '%';
        s.style.minWidth = pct + '%';
        s.style.maxWidth = '';
      });
    }

    function arrowsActive() {
      if (!carouselActive()) return false;
      if (isMobile() && hasMultiSlides()) return true;
      return showArrows;
    }

    function playVisibleVideos() {
      if (!carouselActive()) return;

      slides.forEach(function (slide) {
        const v = slide.querySelector('video[data-autoplay-video]');
        if (!v) return;
        try {
          v.pause();
        } catch (e) {}
      });

      const spv = slidesPerView();
      for (let i = 0; i < spv; i++) {
        const si = index + i;
        if (si >= slides.length) break;
        var sourceIdx = si;
        if (si === 0) sourceIdx = realSlideCount;
        else if (si > realSlideCount) sourceIdx = 1;
        var slide = slides[sourceIdx];
        const v = slide && slide.querySelector('video[data-autoplay-video]');
        if (v) {
          v.muted = v.dataset.bgtkUserUnmuted !== '1';
          v.play().catch(function () {});
        }
      }
    }

    function updateArrows() {
      const max = maxIndex();
      if (!arrowsActive()) {
        qsa(carouselRoot, '[data-bgtk-prev]').forEach(function (btn) {
          btn.disabled = true;
        });
        qsa(carouselRoot, '[data-bgtk-next]').forEach(function (btn) {
          btn.disabled = true;
        });
        return;
      }

      if (loop && slides.length > 0) {
        qsa(carouselRoot, '[data-bgtk-prev]').forEach(function (btn) {
          btn.disabled = false;
        });
        qsa(carouselRoot, '[data-bgtk-next]').forEach(function (btn) {
          btn.disabled = false;
        });
        return;
      }

      qsa(carouselRoot, '[data-bgtk-prev]').forEach(function (btn) {
        btn.disabled = index <= 0;
      });
      qsa(carouselRoot, '[data-bgtk-next]').forEach(function (btn) {
        btn.disabled = index >= max;
      });
    }

    function go(delta) {
      if (!carouselActive()) return;
      if (useCloneLoop && isMobile() && carouselMobile) {
        if (delta > 0 && index < slides.length - 1) {
          index += 1;
          applyTransform(false);
        } else if (delta < 0 && index > 0) {
          index -= 1;
          applyTransform(false);
        }
        updateArrows();
        playVisibleVideos();
        restartTimer();
        return;
      }
      const max = maxIndex();
      var instantWrap = false;
      if (loop && slides.length > 0) {
        if (delta > 0) {
          if (index >= max) {
            index = 0;
            instantWrap = true;
          } else index += 1;
        } else {
          if (index <= 0) {
            index = max;
            instantWrap = true;
          } else index -= 1;
        }
      } else {
        index = Math.max(0, Math.min(max, index + delta));
      }
      applyTransform(instantWrap);
      updateArrows();
      playVisibleVideos();
      restartTimer();
    }

    function stopTimer() {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    }

    function restartTimer() {
      stopTimer();
      if (!carouselActive()) return;
      const ap = isMobile() ? autoplayMobile : autoplayDesktop;
      if (!ap) return;
      if (realSlideCount <= slidesPerView()) return;
      timer = setInterval(function () {
        if (useCloneLoop && isMobile() && carouselMobile) {
          if (index < slides.length - 1) {
            index += 1;
            applyTransform(false);
            updateArrows();
            playVisibleVideos();
          }
          return;
        }
        const max = maxIndex();
        var instantWrap = false;
        if (loop) {
          if (index >= max) {
            index = 0;
            instantWrap = true;
          } else index += 1;
        } else {
          if (index >= max) {
            stopTimer();
            return;
          }
          index += 1;
        }
        applyTransform(instantWrap);
        updateArrows();
        playVisibleVideos();
      }, intervalMs);
    }

    function onResize() {
      setSlideWidths();
      if (!loop) index = Math.min(index, maxIndex());
      applyTransform();
      updateArrows();
      playVisibleVideos();
    }

    qsa(carouselRoot, '[data-bgtk-prev]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        go(-1);
      });
    });
    qsa(carouselRoot, '[data-bgtk-next]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        go(1);
      });
    });

    function onCloneLoopTransitionEnd(e) {
      if (!useCloneLoop || !carouselMobile || !isMobile() || !carouselActive()) return;
      if (e.target !== track) return;
      var pn = e.propertyName || '';
      if (pn !== 'transform' && pn.indexOf('transform') < 0) return;
      /* CodePen LmMJLd: cycle = index === 0 || index > numberOfOriginalSlides → resetPosition */
      if (index === 0 || index > realSlideCount) {
        index = index === 0 ? realSlideCount : 1;
        applyTransform(true);
        playVisibleVideos();
      }
    }
    track.addEventListener('transitionend', onCloneLoopTransitionEnd);

    viewport.addEventListener(
      'touchstart',
      function (e) {
        if (!carouselActive() || realSlideCount <= 1) return;
        const t = e.changedTouches[0];
        touchStartX = t.clientX;
        touchStartY = t.clientY;
      },
      { passive: true }
    );

    viewport.addEventListener(
      'touchend',
      function (e) {
        if (!carouselActive() || realSlideCount <= 1) return;
        const t = e.changedTouches[0];
        const dx = t.clientX - touchStartX;
        const dy = t.clientY - touchStartY;
        if (Math.abs(dx) < 48 || Math.abs(dx) < Math.abs(dy)) return;
        if (dx < 0) go(1);
        else go(-1);
      },
      { passive: true }
    );

    mqMobile.addEventListener('change', function () {
      if (carouselRoot.dataset.bgtkCloneLoop === '1' && (!isMobile() || !carouselMobile)) {
        track.querySelectorAll('[data-bgtk-clone]').forEach(function (el) {
          el.remove();
        });
        slides = qsa(carouselRoot, '[data-bgtk-slide]');
        var prev = index;
        var n = realSlideCount;
        if (prev === 0) index = n - 1;
        else if (prev === n + 1) index = 0;
        else index = Math.max(0, prev - 1);
        useCloneLoop = false;
        delete carouselRoot.dataset.bgtkCloneLoop;
      }
      if (!loop) index = Math.min(index, maxIndex());
      onResize();
      restartTimer();
      sectionEl.dispatchEvent(new CustomEvent('bgtk:carousel-layout'));
    });

    window.addEventListener('resize', function () {
      clearTimeout(carouselRoot._bgtkR);
      carouselRoot._bgtkR = setTimeout(onResize, 120);
    });

    setSlideWidths();
    applyTransform();
    updateArrows();
    playVisibleVideos();
    restartTimer();

    if (hasMultiSlides() && carouselMobile) {
      requestAnimationFrame(function () {
        setSlideWidths();
        applyTransform();
        updateArrows();
        playVisibleVideos();
      });
    }

    return {
      carouselActive: carouselActive,
      playVisibleVideos: playVisibleVideos,
      onLayoutChange: onResize,
    };
  }

  function initSocialProof(sectionEl) {
    if (!sectionEl || sectionEl.dataset.bgtkReady === 'true') return;

    const carouselRoot = sectionEl.querySelector('[data-bgtk-carousel]');
    const carouselApi = carouselRoot ? initCarousel(carouselRoot, sectionEl) : null;

    const cards = sectionEl.querySelectorAll('[data-bgtk-card]');
    const videos = sectionEl.querySelectorAll('[data-autoplay-video]');
    const modal = sectionEl.querySelector('[data-bgtk-modal]');
    const modalVideo = modal ? modal.querySelector('.bgtk-modal-video') : null;
    const modalImage = modal ? modal.querySelector('.bgtk-modal-image') : null;

    function closeModal() {
      if (!modal || !modalVideo) return;
      try {
        modalVideo.pause();
      } catch (e) {}
      modalVideo.removeAttribute('src');
      modalVideo.innerHTML = '';
      modalVideo.removeAttribute('hidden');
      if (modalImage) {
        modalImage.hidden = true;
        modalImage.removeAttribute('src');
        modalImage.alt = '';
      }
      modal.hidden = true;
      document.body.style.overflow = '';
      if (carouselApi && carouselApi.carouselActive()) {
        carouselApi.playVisibleVideos();
      }
    }

    function openModalFromPhoto(img) {
      if (!modal || !modalImage || !img) return;
      const hiRes = img.getAttribute('data-bgtk-photo-src') || img.getAttribute('src') || '';
      if (!hiRes) return;
      try {
        modalVideo.pause();
      } catch (e) {}
      modalVideo.innerHTML = '';
      modalVideo.removeAttribute('poster');
      modalVideo.setAttribute('hidden', '');
      modalImage.src = hiRes;
      modalImage.alt = img.getAttribute('alt') || '';
      modalImage.hidden = false;
      modal.hidden = false;
      document.body.style.overflow = 'hidden';
    }

    function openModalFromVideo(vid) {
      if (!modal || !modalVideo || !vid) return;
      const source = vid.querySelector('source');
      const src = source ? source.getAttribute('src') : '';
      const mime = (source && source.getAttribute('type')) || 'video/mp4';
      if (!src) return;
      const poster = vid.getAttribute('poster') || '';
      try {
        vid.pause();
      } catch (e) {}
      if (modalImage) {
        modalImage.hidden = true;
        modalImage.removeAttribute('src');
        modalImage.alt = '';
      }
      modalVideo.removeAttribute('hidden');
      modalVideo.innerHTML = '';
      const s = document.createElement('source');
      s.src = src;
      s.type = mime;
      modalVideo.appendChild(s);
      if (poster) modalVideo.setAttribute('poster', poster);
      else modalVideo.removeAttribute('poster');
      modal.hidden = false;
      document.body.style.overflow = 'hidden';
      modalVideo.load();
      modalVideo.muted = false;
      const playPromise = modalVideo.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(function () {});
      }
    }

    if (modal) {
      modal.querySelectorAll('[data-close-modal]').forEach(function (closer) {
        closer.addEventListener('click', function (e) {
          e.preventDefault();
          closeModal();
        });
      });
    }

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      if (!modal || modal.hidden) return;
      closeModal();
    });

    function carouselActiveNow() {
      return carouselApi && carouselApi.carouselActive();
    }

    let videoIo = null;
    function setupVideoObserver() {
      if (videoIo) {
        videos.forEach(function (v) {
          try {
            videoIo.unobserve(v);
          } catch (e) {}
        });
        videoIo.disconnect();
        videoIo = null;
      }
      if (!('IntersectionObserver' in window) || !videos.length) return;
      if (carouselActiveNow()) {
        if (carouselApi) carouselApi.playVisibleVideos();
        return;
      }
      videoIo = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            const video = entry.target;
            if (entry.isIntersecting) {
              const p = video.play();
              if (p && typeof p.catch === 'function') p.catch(function () {});
            } else {
              try {
                video.pause();
              } catch (e) {}
            }
          });
        },
        { threshold: 0.25 }
      );
      videos.forEach(function (video) {
        videoIo.observe(video);
      });
    }

    setupVideoObserver();
    sectionEl.addEventListener('bgtk:carousel-layout', setupVideoObserver);

    if (sectionEl.classList.contains('bgtk-section--reveal') && 'IntersectionObserver' in window) {
      const revealObserver = new IntersectionObserver(function (entries, observer) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.15 });

      cards.forEach(function (card) {
        revealObserver.observe(card);
      });
    } else {
      cards.forEach(function (card) {
        card.classList.add('is-visible');
      });
    }

    /* Tap video area: open expanded player in modal (backdrop / X / Escape to close) */
    sectionEl.addEventListener(
      'click',
      function (e) {
        if (e.target.closest('.bgtk-carrow')) return;
        if (e.target.closest('.bgtk-footer-carrows')) return;
        if (e.target.closest('a')) return;
        if (modal && !modal.hidden && e.target.closest('.bgtk-modal')) return;

        const wrap = e.target.closest('.bgtk-media-wrap');
        if (!wrap || !sectionEl.contains(wrap)) return;
        const vid = wrap.querySelector('video[data-autoplay-video]');
        if (vid) {
          e.preventDefault();
          openModalFromVideo(vid);
          return;
        }
        const photo = wrap.querySelector('img[data-bgtk-photo]');
        if (!photo) return;

        e.preventDefault();
        openModalFromPhoto(photo);
      },
      true
    );

    sectionEl.dataset.bgtkReady = 'true';
  }

  function initAll(root) {
    const scope = root || document;
    qsa(scope, '[data-bgtk-section]').forEach(initSocialProof);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
